// extracted by mini-css-extract-plugin
export default {"wrapper":"FlipDisplay_wrapper__1kLf7","row":"FlipDisplay_row__kIZT3","character":"FlipDisplay_character__Jfb8K"};